﻿(function (angular) {
    'use strict';

    angular
        .module('Toyota.Directives')
        .directive('tyAddressAutocomplete', ['$rootScope', function () {
            AddressAutocompleteController.$inject = ['$scope', '$element', '$rootScope', '$q', 'Addresses'];
            function AddressAutocompleteController($scope, $element, $rootScope, $q, Addresses) {

                $scope.init = function () {
                    $scope.addresses = [];

                    $scope.as = {
                        addresses: [],
                        addressAdded: '',
                        type: 'Sales',
                        results: [],
                        loading: false
                    };
                };

                $scope.replaceTag = function ($tag) {
                    $scope.as.addresses = [$tag];
                    $rootScope.$broadcast('address-tag-added', { data: $tag });
                    $scope.as.addressAdded = $tag.text;
                };

                $scope.tagRemoved = function () {
                    $rootScope.$broadcast('address-tag-removed');
                    $scope.as.addressAdded = '';
                };

                $scope.validateText = function (text) {
                    if (text === '') {
                        return;
                    }

                    if ($scope.as.addresses && $scope.as.addresses.length) {
                        $scope.as.text = '';
                        return;
                    }

                    $scope.loadAddresses(text).then(function (addresses) {
                        var foundAddress = addresses.find(function (address) { return address.text === text; });
                        if (foundAddress) {
                            var tagsInputIsolateScope = $element.find('tags-input').isolateScope();
                            tagsInputIsolateScope.$evalAsync(function () {
                                tagsInputIsolateScope.tags = [foundAddress];
                                tagsInputIsolateScope.text = '';
                                $scope.replaceTag(foundAddress);
                            });
                        }
                    });
                };

                $scope.loadAddresses = function (query) {
                    $scope.as.loading = true;

                    var deferred = $q.defer();

                    var x = Addresses(query);

                    x.then(function (results) {
                        $scope.as.loading = false;

                        var addresses = [];

                        angular.forEach(results, function (tag) {
                            addresses.push({
                                text: tag.formatted_address,
                                info: angular.extend({}, tag)
                            });
                        });

                        deferred.resolve(addresses);
                    });

                    return deferred.promise;
                };
            }

            return {
                scope: true,
                restrict: 'A',
                controller: AddressAutocompleteController,
                controllerAs: 'aac',
                bindToController: true
            };
        }]);
})(window.angular);